import { VIEWPORT_ACTION, VIEWPORT_DOMAIN } from 'modules/viewport/constants'
import createViewportUtil from 'modules/viewport/utils/create'
import setReduxAction from 'modules/redux/actions/set'

/**
 * Updates the viewport.
 * @param  {Object} [viewport]
 * @returns {Function}
 */
function updateViewportAction (viewport) {
  return (dispatch) => {
    dispatch(
      setReduxAction({
        type: VIEWPORT_ACTION.UPDATE,
        payload: {
          path: VIEWPORT_DOMAIN,
          value: viewport || createViewportUtil()
        }
      })
    )
  }
}

export default updateViewportAction
